<template>
  <div class="pool-header">
    <div class="pool-title">
      <TokenInfo
        :token-entity="pool?.tokenEntities?.fromTokenEntity as
    IPersistedTokenExtended"
        :is-mobile="true"
      />
      <span class="divider">–</span>
      <TokenInfo
        :token-entity="pool?.tokenEntities?.toTokenEntity as
        IPersistedTokenExtended"
        :is-mobile="true"
      />
    </div>
    <div class="info">
      <PoolInfo
        v-if="!isVersionV1"
        :pool="pool as ITablePool"
        :is-mobile="true"
      />
      <PoolInfoV1 v-else :pool="pool as ITablePoolV1" :is-mobile="true" />
    </div>
  </div>
</template>

<script lang="ts" setup>
import { IPersistedTokenExtended, useTablePoolStore } from '@/store';
import { ITablePool, ITablePoolV1 } from '@/types/pools';
import { DynamicDialogInstance } from 'primevue/dynamicdialogoptions';
import { inject, Ref } from 'vue';
import { PoolInfo, TokenInfo, PoolInfoV1 } from '@/components/Pools/Table';
import { VERSION_1 } from '@/constants';

type DialogRef = Omit<DynamicDialogInstance, 'data'> & {
  data: {
    pool: ITablePool | ITablePoolV1;
  };
};
const dialogRef = inject<Ref<DialogRef>>('dialogRef');
const pool = dialogRef?.value.data.pool;

const tablePoolStore = useTablePoolStore();

const isVersionV1 = tablePoolStore.version === VERSION_1;
</script>

<style lang="scss" scoped src="./style.scss" />

<style lang="scss">
.p-dialog {
  min-width: 310px;
  .p-dialog-header {
    padding: 20px 20px 12px 20px;
    position: relative;

    .p-dialog-header-icons {
      position: absolute;
      top: 20px;
      right: 20px;
      .p-dialog-header-icon {
        width: initial;
        height: initial;
      }
    }
  }
}
</style>
